<template>
  <layout>
    <div style="padding: 32px">
      <at-widget-booking
        ref="widget"
        :endpoint="endpoint"
        :stripe-key="stripeKey"
        is-personal
        hide-ride-types="transfer,delivery"
        @ready="widgetReady"
      />
    </div>
  </layout>
</template>

<script>
import { mapState } from 'vuex'
import HasWidgetMixin from '../../../console/src/bookings/HasWidgetMixin'

export default {
  name: 'Add',

  mixins: [HasWidgetMixin],

  computed: {
    ...mapState('admin-auth', ['token']),
  },

  watch: {
    token() {
      // whenever token changes, update widget token also
      this.mapAccountToWidgetUser()
    },
  },

  async mounted() {
    const setAccount = () => {
      this.whenWidget(() => {
        this.$refs.widget.$store.dispatch('setAccount', {
          ...this.$account,
          token: this.token,
        })
        // force commit state cause it resets on widget loaded
        this.$refs.widget.$store.commit('airports/setHiddenRideTypes', [
          'transfer',
          'delivery',
        ])
        this.$refs.widget.$store.commit('airports/setSelectedTab', 'cityTaxi')
      })
    }

    if (this.$account) {
      setAccount()
    }
    this.$root.$on('account-loaded', setAccount)
  },
}
</script>
